





























import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { User, Worker, isWorker, PatientInRelative } from '@/types/user'

@Component({
  components: {
    CallCheckboxInput: () => import('@/components/call/CallCheckboxInput.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class CallWorkerRelativeList extends Vue {
  $store!: ExStore
  isLoading = true

  async beforeCreate() {
    await this.$store.dispatch('team/updatePatients')
    await this.$store.dispatch('relative/updateList')
    this.isLoading = false
  }

  get user() {
    return this.$store.getters['user/userInfo']
  }

  get relativeInfo() {
    return this.$store.getters['user/relativeInfo']
  }

  get workers() {
    return this.$store.getters['team/workersForPatientUser']
  }

  get relatives() {
    if (this.user.isPatientRelative) return []
    return this.$store.getters['relative/activeRelativeList']
  }

  getUserName(user: User | PatientInRelative) {
    return `${user.lastName}${user.firstName}`
  }

  getOccupationName(user: Worker | PatientInRelative) {
    if (!isWorker(user)) return '患者'
    return user.occupation ? user.occupation.name : ''
  }
}
